import OrderNewAccount from "@/pages/createAccount/OrderNewAccount";
import AcceptNewAccount from "@/pages/createAccount/AcceptNewAccount";
import CreateNewAccount from "@/pages/createAccount/CreateNewAccount";
import CreateExecute from "@/pages/createAccount/CreateExecute";

export default [
  // アカウント作成
  {
    path: "/order_new_account",
    name: "OrderNewAccount",
    component: OrderNewAccount,
    meta: {
      title: 'アカウント作成お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      description: 'アカウント作成お申込みはこちらから。 - desknet\'s NEO・ChatLuck（クラウド版）のサポートサイトです。当サイトでは、お客様情報・ご契約数・オプションサービス・お支払い方法のご確認・ご変更が可能です。',
    },
    props: true,
  },
  // アカウント作成受付
  {
    path: "/accept_new_account",
    name: "AcceptNewAccount",
    component: AcceptNewAccount,
    meta: {
      title: 'アカウント作成お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true,
  },
  // アカウント作成登録
  {
    path: "/create_new_account",
    name: "CreateNewAccount",
    component: CreateNewAccount,
    meta: {
      title: 'アカウント作成お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  },
  // アカウント作成実行
  {
    path: "/create_execute",
    name: "CreateExecute",
    component: CreateExecute,
    meta: {
      title: 'アカウント作成お申込み - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
    },
    props: true
  }
]
